import { useIntl } from "react-intl";

export { FormattedMessage as FM } from "react-intl";

export const useFM = () => {
  return useIntl().formatMessage;
};
